module.exports = __webpack_public_path__ + "img/add-to-home-screen.2cac0db3.gif";